<template>
  <div class="change-perms change-perms-view">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('file.share.permissionSettings')"
      @click-left="handleClose"
      @click-right="handleConfirm"
    >
      <i class="iconfont icon-back" slot="left"/>
      <span :class="['btn btn-text', saveDisabled && 'disabled']" slot="right">{{$t('base.save')}}</span>
    </van-nav-bar>
    <div v-if="actionName === 'link'" class="access-item">
      <div class="access-item-title">
        {{$t('file.share.accessPermisson')}}
        <p v-show="access === 'public'">分享需符合国家法律法规，否则无法分享</p>
      </div>
      <div
        :class="['access-item-choice', !publicShare && 'disabled']"
        @click="changeAccess('public', !publicShare)"
      >
        {{$t('file.share.anyoneCanAccess')}}
        <svg-icon v-if="access === 'public'" icon="Selected1" cls="type-icon" />
      </div>
      <div
        v-if="enableCompanyShare"
        :class="['access-item-choice', !companyShare && 'disabled']"
        @click="changeAccess('company', !companyShare)"
      >
        {{$t('file.share.memberOnlyAccess')}}
        <svg-icon v-if="access !== 'public'" icon="Selected1" cls="type-icon" />
      </div>
    </div>
    <div class="perm-item">
      <span class="label">{{$t('file.share.downloadable')}}</span>
      <van-switch :class="[!enableSelectDownload && 'van-switch--disabled']" :value="checked" @input="onSwitch"/>
    </div>
    <div class="perm-item date-item" @click="toggleDateTimePicker">
      <span class="label">{{$t('file.share.visitDuration')}}</span>
      <span class="expire-date">
        <span>{{due_time ? expireDate : $t('file.share.neverExpire')}}</span>
        <i v-if="due_time" class="iconfont icon-close-small" @click.stop="clearDate"/>
        <i v-else class="iconfont icon-arrow-next"></i>
      </span>
    </div>
    <div class="perm-item">
      <span class="label">{{$t('file.share.passowrd')}}
      </span>
      <van-field
        ref="field"
        v-model="password"
        :placeholder="$t('file.share.passowrdPlaceHolder')"
        spellcheck="false"
        maxlength="32"
        input-align="right"
        clearable
        type="text"
      />
    </div>
    <van-popup
      class="normal-sheet sheet-datetime-picker"
      v-model="showDateTimePicker"
      position="bottom"
    >
      <van-datetime-picker
        v-model="dateTime"
        type="date"
        :min-date="minDate"
        @cancel="toggleDateTimePicker"
        @confirm="changeDueTime"
      />
    </van-popup>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import {toast, formatDate, confirm, getDefaultDueTime} from '@/utils/common'
import SvgIcon from '../utils/SvgIcon'
import config from '@/config'

export default {
  name: 'ChangePerms',
  i18n,
  components: {
    SvgIcon
  },
  props: {
    actionName: String,
    actionItem: Object,
    headerItem: Object,
    perms: Object
  },
  model: {
    prop: 'perms',
    event: 'perms-set'
  },
  data () {
    return {
      saveDisabled: false,
      access: this.perms.access,
      password: this.perms.password,
      checked: !this.perms.disable_download,
      due_time: this.perms.due_time * 1000,
      dateTime: this.perms.due_time ? new Date(this.perms.due_time * 1000) : getDefaultDueTime(),
      showDateTimePicker: false,
      minDate: new Date()
    }
  },
  computed: {
    expireDate () {
      return formatDate(this.due_time, '%YY-%MM-%DD')
    },
    companyShare () {
      return this.actionItem.owned_by && this.actionItem.owned_by.enterprise_id === config.enterprise_info.id && config.enterprise_info.share_with_colleagues_disallowed !== 1
    },
    enableCompanyShare () {
      return !config.enterprise_info.is_personal_user_enterprise
    },
    publicShare () {
      return !this.actionItem.is_share_link_public_access_disabled
    },
    enableSelectDownload () {
      return !this.actionItem.is_share_link_download_disabled
    }

  },
  watch: {
  },
  methods: {
    handleClose () {
      const data = {
        access: this.access,
        password: this.password,
        disable_download: !this.checked,
        due_time: parseInt(this.due_time / 1000)
      }
      let changed = Object.keys(data).some(key => data[key] !== this.perms[key])
      if (!changed) {
        this.$emit('close-popup')
      } else {
        confirm({
          className: 'dialog',
          message: i18n.t('file.share.confirmSave'),
          confirmButtonText: i18n.t('base.save'),
          cancelButtonText: i18n.t('base.notsave')
        }).then(() => {
          this.$emit('perms-set', data)
          toast(i18n.t('file.share.accessPermissonUpdated'))
          this.$emit('close-popup')
        }).catch(() => {
          this.$emit('close-popup')
        })
      }
    },
    handleConfirm () {
      const data = {
        access: this.access,
        password: this.password,
        disable_download: !this.checked,
        due_time: parseInt(this.due_time / 1000)
      }
      this.$emit('perms-set', data)
      toast(i18n.t('file.share.accessPermissonUpdated'))
      this.$emit('close-popup')
    },
    onSwitch () {
      if (!this.enableSelectDownload) {
        toast(i18n.t('file.share.enterpriseDownloadForbidden'))
        return false
      } else {
        this.checked = !this.checked
      }
    },
    changeAccess (key, disabled) {
      if (disabled) {
        toast(i18n.t('file.share.disabled.publicDisabled'))
        return
      }
      this.access = key
    },
    clearDate () {
      this.due_time = 0
    },
    toggleDateTimePicker () {
      this.showDateTimePicker = !this.showDateTimePicker
    },
    changeDueTime (date) {
      this.due_time = new Date(date.toLocaleDateString()).getTime() + 86400000 - 1000
      this.toggleDateTimePicker()
    }
  }
}
</script>
<style lang="postcss" scoped>
@import 'variables';

.change-perms-view {
  background-color: var(--pageBgColor);
}

.change-perms {

  & .access-item {
    margin-top: 30px;

    & .access-item-title {
      color: var(--secondlyTitle);
      font-size: 12px;
      height: 17px;
      line-height: 17px;
      margin-bottom: 6px;
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #999999;
    }

    & .access-item-choice {
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & + .access-item-choice {
        border-top: 1px solid var(--sepLineColor);
      }

      &.disabled {
        color: #d1d4e0;
        opacity: 1;
      }
    }
  }

  & .perm-item {
    background-color: #fff;
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
    display: flex;
    align-items: center;

    &.date-item {
      padding-right: 0;
    }

    & .label {
      flex: 1 0 auto;
    }

    & .van-field {
      // flex: 1 1 auto;
      font-size: 16px;
      line-height: 50px;
      padding: 0;
    }

    & .expire-date {
      color: var(--secondlyText);

      & .iconfont {
        color: var(--contentIcon);
        display: inline-block;
        padding-left: 10px;
        height: 100%;
        padding-right: 15px;
      }
    }

    & input {
      text-align: right;
    }
  }
}
</style>
